// ABOUTME: Shown instead of the app when the Firebase env vars are missing.
// ABOUTME: Names each missing var, since otherwise the page would be blank.

function MissingConfig({ vars }: { vars: string[] }) {
  return (
    <main className="mx-auto max-w-xl p-8 text-[var(--color-text-primary)]">
      <h1 className="font-heading text-2xl mb-3">Firebase isn't configured</h1>
      <p className="mb-3 text-[var(--color-text-secondary)]">
        These env vars are missing from this build. Copy <code>.env.local</code> into this checkout,
        or set them on the host, then restart.
      </p>
      <ul className="font-mono text-sm">
        {vars.map((name) => (
          <li key={name}>{name}</li>
        ))}
      </ul>
    </main>
  );
}

export default MissingConfig;
